module.exports = __webpack_public_path__ + "img/p5.98ac91d6.png";